var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"big_add_btn",on:{"click":_vm.onClick}},[_c('i',{staticClass:"el-icon-plus avatar-uploader-icon fs12"}),_c('span',{staticClass:"SysFontR fs12"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }